import { render, staticRenderFns } from "./app.clients.vue?vue&type=template&id=84732a8c&lang=pug&"
import script from "./app.clients.vue?vue&type=script&lang=js&"
export * from "./app.clients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports